import { render, staticRenderFns } from "./PoweredByLogo.vue?vue&type=template&id=7441fae2&scoped=true&"
var script = {}
import style0 from "./PoweredByLogo.vue?vue&type=style&index=0&id=7441fae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7441fae2",
  null
  
)

export default component.exports